import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { FaDownload, FaRegCommentAlt, FaQrcode, FaCopy, FaExternalLinkAlt, FaDesktop, FaVideo } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { API } from 'aws-amplify';
import QRCode from 'qrcode.react';
import AssetTasks from '../AssetTasks/AssetTasks';
import AssetDocs from '../AssetDocs/AssetDocs';
import TaskLog from '../../../Tasks/TaskDetail/TaskLog/TaskLog';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import './AssetInfo.css';
import Map from '../../../../components/Map/Map';
import { getMapView } from '../../../../theme/palette';
import { useDisplayMode } from '../../../../theme/displayMode';
import Moment from 'react-moment';
import { useToasts } from 'react-toast-notifications';
import { useI18n } from '../../../../i18n';

import Tabs  from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TabContent from 'react-bootstrap/TabContent';

const isMeathEnv = process.env.REACT_APP_GLOB_APP_ENV === 'meathcc';

const openAssetLink = (link) => {
    if (!link || !String(link).trim()) return;
    const trimmed = String(link).trim();
    const url = /^https?:\/\//i.test(trimmed) ? trimmed : `http://${trimmed}`;
    window.open(url, '_blank', 'noopener,noreferrer');
};

const Field = ({ label, children, wide }) => {
    const empty = children === undefined || children === null || children === '';
    return (
        <div className={`info-field${wide ? ' is-wide' : ''}`}>
            <span className="info-label">{label}</span>
            <div className={`info-value${empty ? ' is-empty' : ''}`}>{empty ? '—' : children}</div>
        </div>
    );
};

async function addMarkers(map, links) {
    await window.google.maps.importLibrary("marker");
    let infoWindow
    links.forEach((link, index) => {
      let icon = document.createElement('img');
      icon.src = link.icon;
      const marker = new window.google.maps.marker.AdvancedMarkerElement({
        map,
        position: link.coords,
        title: link.title,
        content: icon
      })
      marker.addListener(`click`, () => {
        if (infoWindow !== void 0) {
          infoWindow.close();
        }
        var infoWindowOptions = {
            content: link.content
        };
        infoWindow = new window.google.maps.InfoWindow(infoWindowOptions);
        infoWindow.open(map, marker);

      })
    })
  }

const AssetInfo = (props) => {
    const { t, tCatalog } = useI18n();
    const { theme } = useDisplayMode();
    const mapView = getMapView();
    const [assetInfo, setAssetInfo] = useState([]);
    const [usersInfo, setUsersInfo] = useState([]);
    const [loadedAssetInfo, setLoadedAssetInfo] = useState(false);
    const [mapTasks, setMapTasks] = useState([]);
	const [assetNotes, setAssetNotes] = useState([]);
    const [showQr, setShowQr] = useState(false);
    const { addToast } = useToasts();

    const params = {
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }

	useEffect(()=>{
		const fetchNotes = async () => {
			let data = []
			let notes = []
            const boardId = "default";
            const board = await API.get('board','/' + boardId, params);

            if (board.data && board.data.lanes) {
                data = board.data;
            }else{
                data = {lanes: []};
			}

			for (let i = 0; i < data.lanes.length; i++) {
				data.lanes[i].cards
					.filter(item => item.assetId !== undefined)
					.forEach(item => {
						notes.push({
							assetId: item.assetId,
							asset: item.asset,
							note: item.body,
							date: item.dateCreated,
							name: item.name
						});
					})
			}

			setAssetNotes(notes);
		}
		fetchNotes();
    }, []);

    useEffect(()=>{
        if (props.match.params.id) {
            API.get('assets','/' + props.match.params.id, params)
            .then(asset => {
                setAssetInfo(asset);
                setLoadedAssetInfo(true)
            });
        }
    }, []);

    useEffect(()=>{
		API.get('users','/', params)
        .then(res => {
            let userList = [];
            res.Users.forEach((item) => {
                let user = {}
                user.id = item.Username;
                item.Attributes.forEach((e) => {
                    if (e.Name === 'name')
                        user.name = e.Value;
                })
                userList.push(user);
				setUsersInfo(userList);
            })
		})
	},[])

    useEffect(()=>{
        let link = []
        if (props.match.params.id && loadedAssetInfo) {
            if (assetInfo.hp_site === true) {
                assetInfo.hp_site_str = "High"
            } else {
                assetInfo.hp_site_str = "Low"
            }

            if (assetInfo.installation_date) {
                assetInfo.installation_date_str = <Moment local format='DD-MM-YYYY' date={ assetInfo.installation_date } />
            }

            if (assetInfo.upgrade_date) {
                assetInfo.upgrade_date_str = <Moment local format='DD-MM-YYYY' date={ assetInfo.upgrade_date } />
            }

            let lat = 0;
            let long = 0;
            if (assetInfo.latitude) {
                lat = parseFloat(assetInfo.latitude);
            }
            if (assetInfo.longitude) {
                long = parseFloat(assetInfo.longitude);
            }
            if (Number.isFinite(lat) && Number.isFinite(long) && !(lat === 0 && long === 0)) {
                link.push({
                    coords: { lat: lat, lng: long },
                    icon: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
                    content:'<div class="map-div">'+
                            '<p><strong>'+ assetInfo.site_address +'</strong></p>' +
                            '<p>'+ assetInfo.district +'</p>' +
                            '<p class="text-secondary">'+ lat +', '+ long +'</p>' +
                            '</div>'
                });
            }

            setMapTasks(link);
            if (typeof props.onAssetLoaded === 'function') {
                props.onAssetLoaded({ ...assetInfo });
            }
        }
    }, [loadedAssetInfo]);

    useEffect(()=>{
        if (props.match.params.id && loadedAssetInfo) {
            assetInfo.notes = assetNotes.filter(item => item.assetId ===  assetInfo.assetId);
        }
    }, [loadedAssetInfo, assetNotes]);

    const lat = parseFloat(assetInfo.latitude);
    const lng = parseFloat(assetInfo.longitude);
    const hasCoords = Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0);

    const mapOptions = useMemo(() => ({
        center: hasCoords ? { lat, lng } : mapView.center,
        zoom: hasCoords ? 16 : mapView.zoom,
        scrollwheel: true,
        mapId: "4ada5c0171a1e340",
        colorScheme: theme === 'dark' ? 'DARK' : 'LIGHT',
    }), [hasCoords, lat, lng, mapView.center.lat, mapView.center.lng, mapView.zoom, theme]);

    const mapProps = {
        options: mapOptions,
        onMount: addMarkers,
        onMountProps: mapTasks,
        className: 'gmaps-asset'
    };

    const MemoMap = useCallback(<Map {...mapProps} />, [mapProps]);

    const downloadQR = () => {
        const canvas = document.getElementById("qrCode");
        if (!canvas) return;
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = "qrCode_"+ assetInfo.site_ref +".png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        };

    const copyCoords = () => {
        if (!hasCoords) return;
        const text = `${lat}, ${lng}`;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(() => {
                addToast(t('toast.coordsCopied'), { appearance: 'success', autoDismiss: true });
            }).catch(() => {
                addToast(t('toast.coordsCopyFail'), { appearance: 'error' });
            });
        }
    };

    const isSignType = assetInfo.type === 'Sign - Other' || assetInfo.type === 'Periodic Speed Limit Sign' || assetInfo.type === 'School Warning Sign';
    const isSchoolType = assetInfo.type === 'School Warning Sign' || assetInfo.type === 'Periodic Speed Limit Sign';
    const boardNotes = assetInfo.notes || [];

    return (
    <div className="AssetInfo">
            <Tabs defaultActiveKey="details" transition={false} id="tab_asset_det">
            <Tab eventKey="details" title={t('actions.details')}>
            <TabContent>
            <div className="asset-layout">
                <div className="asset-main">
                {!loadedAssetInfo ? (
                    <div className="map-empty"><span>{t('assets.loadingAsset')}</span></div>
                ) : (
                <>
                <section className="info-section">
                    <div className="section-head">
                        <h4>{t('fields.siteDetails')}</h4>
                        <div className="section-actions">
                            <Button type="button" size="sm" variant="outline-secondary" onClick={() => setShowQr(true)}>
                                <FaQrcode /> {t('actions.viewQr')}
                            </Button>
                            {(boardNotes.length > 0) ? (
                                <OverlayTrigger
                                    trigger="click"
                                    placement="bottom"
                                    delay={{ show: 250, hide: 400 }}
                                    overlay={<Popover id="pop">
                                            <Popover.Content className="popover-content">
                                            {boardNotes.map((i,key) =>
                                                <div key={key} className="note-item">
                                                    <FaRegCommentAlt />
                                                    <div>
                                                        {i.note}<br/>
                                                        <span className="small">{i.name} - <Moment local format='DD-MM-YYYY' date={ i.date } /></span>
                                                    </div>
                                                </div>
                                            )}
                                            </Popover.Content>
                                            </Popover>}
                                        >
                                    <Button type="button" variant="outline-secondary" size="sm">
                                        <FaRegCommentAlt /> {t('actions.notes')}
                                    </Button>
                                </OverlayTrigger>
                            ):null}
                            {isMeathEnv && assetInfo.controller_link ? (
                                <Button
                                    type="button"
                                    variant="outline-secondary"
                                    size="sm"
                                    title={assetInfo.controller_link}
                                    onClick={() => openAssetLink(assetInfo.controller_link)}
                                >
                                    <FaDesktop /> {t('fields.controller')}
                                </Button>
                            ) : null}
                            {isMeathEnv && assetInfo.camera_link ? (
                                <Button
                                    type="button"
                                    variant="outline-secondary"
                                    size="sm"
                                    title={assetInfo.camera_link}
                                    onClick={() => openAssetLink(assetInfo.camera_link)}
                                >
                                    <FaVideo /> {t('actions.camera')}
                                </Button>
                            ) : null}
                        </div>
                    </div>
                    <div className="info-grid">
                        <Field label={t('fields.siteRef')}>{assetInfo.site_ref}</Field>
                        <Field label={t('common.district')}>{assetInfo.district}</Field>
                        <Field label={t('fields.chargeCode')}>{assetInfo.charge_code}</Field>
                        <Field label={t('common.type')}>{tCatalog(assetInfo.type)}</Field>
                        <Field label={t('fields.prioritySite')}>{assetInfo.hp_site_str === 'High' ? t('assets.high') : assetInfo.hp_site_str === 'Low' ? t('assets.low') : assetInfo.hp_site_str}</Field>
                        <Field label={t('fields.siteAddress')}>{assetInfo.site_address}</Field>
                        {isMeathEnv && assetInfo.controller_link ? (
                            <Field label={t('fields.controllerLink')}>
                                <button type="button" className="info-link" onClick={() => openAssetLink(assetInfo.controller_link)}>
                                    {assetInfo.controller_link}
                                </button>
                            </Field>
                        ) : null}
                        {isMeathEnv && assetInfo.camera_link ? (
                            <Field label={t('fields.cameraLink')}>
                                <button type="button" className="info-link" onClick={() => openAssetLink(assetInfo.camera_link)}>
                                    {assetInfo.camera_link}
                                </button>
                            </Field>
                        ) : null}
                    </div>
                </section>

                {!isSignType ? (
                    <>
                    <section className="info-section">
                        <h4>{t('fields.equipmentDetails')}</h4>
                        <div className="info-grid">
                            <Field label={t('fields.controller')}>{assetInfo.controller}</Field>
                            <Field label={t('fields.tmrpn')}>{assetInfo.tmrpn}</Field>
                            <Field label={t('fields.signalHead')}>{assetInfo.signal_head}</Field>
                            <Field label={t('fields.operatingMode')}>{assetInfo.operating_mode}</Field>
                            <Field label={t('fields.pushButton')}>{assetInfo.push_button}</Field>
                            <Field label={t('fields.installationDate')}>{assetInfo.installation_date_str}</Field>
                        </div>
                    </section>
                    <section className="info-section">
                        <h4>{t('fields.technicalInfo')}</h4>
                        <div className="info-grid">
                            <Field label={t('fields.supplySource')}>{assetInfo.supply_source}</Field>
                            <Field label={t('fields.latitude') + ' / ' + t('fields.longitude')}>
                                {(assetInfo.supply_gps_lat) ? assetInfo.supply_gps_lat +', '+ assetInfo.supply_gps_long : ''}
                            </Field>
                            <Field label={t('fields.powerConsumption')}>{assetInfo.power_consumption}</Field>
                            <Field label={t('fields.elvLv')}>{assetInfo.elv_lv}</Field>
                            <Field label={t('fields.billedConsumption')}>{assetInfo.billed_consumption}</Field>
                            <Field label={t('fields.upgradeDate')}>{assetInfo.upgrade_date_str}</Field>
                            <Field label={t('fields.halogenLed')}>{assetInfo.halogen_led}</Field>
                            <Field label={t('fields.specialCondition')} wide>{assetInfo.observations}</Field>
                        </div>
                    </section>
                    </>
                ) : (
                    <section className="info-section">
                        <h4>{t('fields.equipmentDetails')}</h4>
                        <div className="info-grid">
                            <Field label={t('fields.makeModel')}>{assetInfo.make}</Field>
                            <Field label={t('fields.supplySource')}>{assetInfo.supply_source}</Field>
                            <Field label={t('fields.signDisplay')}>{assetInfo.sign_display}</Field>
                            <Field label={t('fields.installedBy')}>{assetInfo.installed_by}</Field>
                            <Field label={t('fields.installationDate')}>{assetInfo.installation_date_str}</Field>
                            <Field label={t('fields.additionalInfo')} wide>{assetInfo.observations}</Field>
                        </div>
                    </section>
                )}

                {isSchoolType ? (
                <section className="info-section">
                    <h4>{t('fields.schoolDetails')}</h4>
                    <div className="info-grid">
                        <Field label={t('fields.schoolName')}>{assetInfo.school_name}</Field>
                        <Field label={t('fields.phoneNumber')}>{assetInfo.school_number}</Field>
                        <Field label={t('fields.email')}>{assetInfo.school_email}</Field>
                    </div>
                    <div className="info-table">
                        <div className="info-table-row is-head">
                            <span>{t('fields.schoolTimes')}</span>
                            <span>{t('fields.signSwitchOn')}</span>
                            <span>{t('fields.signSwitchOff')}</span>
                        </div>
                        {assetInfo.school_det && assetInfo.school_det.map((item, i) =>
                            <div key={"sch_det_"+ i} className="info-table-row">
                                <span>{item.school_times || '—'}</span>
                                <span>{item.school_switch_on || '—'}</span>
                                <span>{item.school_switch_off || '—'}</span>
                            </div>
                        )}
                    </div>
                </section>
                ) : null}

                <section className="info-section location-section">
                    <div className="map-head">
                        <h4>{t('common.location')}</h4>
                        {hasCoords ? (
                            <div className="map-coords">
                                <span>{lat}, {lng}</span>
                                <Button type="button" size="sm" variant="outline-secondary" onClick={copyCoords}>
                                    <FaCopy /> {t('actions.copy')}
                                </Button>
                                <Button
                                    type="button"
                                    size="sm"
                                    variant="outline-secondary"
                                    onClick={() => window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`, '_blank', 'noopener,noreferrer')}
                                >
                                    <FaExternalLinkAlt /> {t('actions.googleMaps')}
                                </Button>
                            </div>
                        ) : null}
                    </div>
                    {hasCoords ? MemoMap : (
                        <div className="map-empty">
                            <strong>{t('assets.noGps')}</strong>
                            <span>{t('assets.noGpsHint')}</span>
                        </div>
                    )}
                </section>
                </>
                )}
                </div>
                <div className="asset-history">
                    <TaskLog key="log" assetId={props.match.params.id}
                    asset={assetInfo} users={usersInfo}/>
                </div>
            </div>
            </TabContent>
            </Tab>
            <Tab eventKey="tasks" title={t('nav.tasks')}>
                <TabContent>
                    <AssetTasks key="tasks" assetId={props.match.params.id}
                    users={usersInfo} {...props} />
                </TabContent>
            </Tab>
            <Tab eventKey="docs" title={t('actions.documents')}>
                <TabContent>
                    <AssetDocs key="docs" assetId={props.match.params.id} site_ref={assetInfo.site_ref} {...props}
                    asset={assetInfo} />
                </TabContent>
            </Tab>
            </Tabs>

            <div className="qr-offscreen" aria-hidden="true">
                <QRCode
                    id="qrCode"
                    value={props.match.params.id}
                    size={180}
                    level={"H"}
                    includeMargin={false}
                />
            </div>
            <Modal show={showQr} onHide={() => setShowQr(false)} centered animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('assets.qrTitle')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="qr-modal-body">
                    <QRCode
                        value={props.match.params.id}
                        size={180}
                        level={"H"}
                        includeMargin={true}
                    />
                    <div className="qr-modal-ref">{assetInfo.site_ref || t('nav.assets')}</div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={downloadQR}>
                        <FaDownload /> {t('actions.download')}
                    </Button>
                    <Button variant="secondary" size="sm" onClick={() => setShowQr(false)}>{t('common.close')}</Button>
                </Modal.Footer>
            </Modal>
    </div>
        );
}

export default AssetInfo;
